import { LandingContentBlock as s } from "@rei/landing-content-block";
import { palettes as d } from "@rei/landing-palettes";
import p from "@rei/landing-image-component";
import { resolveComponent as i, openBlock as c, createElementBlock as _, normalizeStyle as u, normalizeClass as g, createBlock as f, mergeProps as y, createCommentVNode as b, createElementVNode as k, createVNode as v, normalizeProps as B, guardReactiveProps as V } from "vue";
const C = (n, a) => {
  const e = n.__vccOpts || n;
  for (const [o, t] of a)
    e[o] = t;
  return e;
}, L = {
  name: "LandingMiniBanner",
  components: {
    LandingContentBlock: s,
    LandingImageComponent: p
  },
  props: {
    content: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    palette: {
      type: Object,
      required: !1,
      default: () => ({
        surface: "primary"
      })
    },
    padding: {
      type: String,
      required: !1,
      default: "normal"
    },
    media: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  data() {
    var n;
    return {
      paletteVars: (n = d(this.palette)) == null ? void 0 : n.cssSurfacePaletteVars()
    };
  }
}, q = {
  class: "mini-banner__inner"
};
function x(n, a, e, o, t, O) {
  var r;
  const l = i("landing-image-component"), m = i("landing-content-block");
  return c(), _("div", {
    style: u(t.paletteVars),
    class: g(["mini-banner", `mini-banner--padding-${e.padding}`])
  }, [(r = e.media) != null && r.images ? (c(), f(l, y({
    key: 0,
    "data-ui": "image-component",
    class: "mini-banner__background-image"
  }, e.media), null, 16)) : b("", !0), k("div", q, [v(m, B(V(e.content)), null, 16)])], 6);
}
const M = /* @__PURE__ */ C(L, [["render", x]]);
export {
  M as default
};
